import { AbstractPmsApiService } from './abstract.service';
import { ReservationInvoice } from '../models';

/**
 * @class ReservationInvoicePmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<ReservationInvoice>}
 */
export class ReservationInvoicePmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/reservation/:reservationId/invoice(/:id)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @param params
     * @returns {ReservationInvoice}
     * @protected
     */
    newModel(attributes, ...params) {

        return new ReservationInvoice(attributes);
    }

    /**
     * Load paginated list of reservation invoices
     *
     * @param {Object=} params
     * @param {Reservation=} reservation
     *
     * @returns {Promise.<PaginationCollection<ReservationInvoice>>}
     */
    get(params = {}, reservation) {

        const url = this.url({
            reservationId: reservation.id
        });

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    /**
     * Get next invoice model
     *
     * @param {Reservation=} reservation
     *
     * @returns {Promise.<ReservationInvoice>}
     */
    getNextInvoice(reservation) {

        const url = this.url({
            reservationId: reservation.id
        });

        return this.http
            .get(url + '/next-invoice', {
                headers: this.authHeaders,
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * Create new reservation invoice
     *
     * @param {Reservation=} reservation
     * @param {Object=} invoice
     *
     * @returns {Promise.<ReservationInvoice>}
     */
    create(reservation, invoice) {

        const url = this.url({
            reservationId: reservation.id
        });

        return this.http
            .post(url, invoice, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * Email invoice or credit note to reservation guest
     *
     * @param {Reservation=} reservation
     * @param {ReservationInvoice=} invoice
     *
     * @returns {Promise.<*>}
     */
    email(reservation, invoice) {

        const url = this.url({
            reservationId: reservation.id,
            id: invoice.id,
        });

        return this.http
            .get(url + '/email', {
                headers: this.authHeaders,
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }

    /**
     * Create credit note over invoice
     *
     * @param {Reservation=} reservation
     * @param {ReservationInvoice=} invoice
     * @param {Object=} creditNote
     *
     * @returns {Promise.<*>}
     */
    createCreditNote(reservation, invoice, creditNote) {

        const url = this.url({
            reservationId: reservation.id,
            id: invoice.id,
        });

        return this.http
            .post(url + '/credit-note', creditNote, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }

    /**
     * Get next credit note model
     *
     * @param {Reservation=} reservation
     * @param {ReservationInvoice=} invoice
     *
     * @returns {Promise.<Object>}
     */
    getNextCreditNote(reservation, invoice) {

        const url = this.url({
            reservationId: reservation.id,
            id: invoice.id,
        });

        return this.http
            .get(url + '/next-credit-note', {
                headers: this.authHeaders,
            })
            .then(this.getDataExtractor())
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/reservation-invoices.service.js